import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { DecourseDetailsComponent } from './decourse-details.component';
import { TranslateModule } from '../../../shared/translate/translate.module';
import { TitleBtnModule } from '../../../shared/components/title-btn/title-btn.module';
import { MatExpansionModule } from '@angular/material';
import { AlertCommentDetailsModule } from '../../alert/details/comment/details/alert-comment-details.module';
import { DecourseCommentAddModule } from './comment/add/decourse-comment-add.module';

@NgModule({
  declarations: [DecourseDetailsComponent],
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    TitleBtnModule,
    MatExpansionModule,
    AlertCommentDetailsModule,
    DecourseCommentAddModule
  ],
  exports: [DecourseDetailsComponent]
})
export class DecourseDetailsModule { }
